import { Calendar } from "./components";
import { SchedulerDialog } from "./SchedulerDialog";

const Scheduler = Calendar;
Scheduler.Dialog = SchedulerDialog;

export default Scheduler;
